import { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { KeyRound, ArrowRight, Loader2, MailCheck } from 'lucide-react';

/** Primo passo del recupero: si chiede l'email e parte il link. */
export const ForgotPasswordStep = ({ initialEmail = '', onBack }) => {
  const { API } = useAuth();
  const [email, setEmail] = useState(initialEmail);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Invio non riuscito');
    } finally {
      setBusy(false);
    }
  };

  if (sent) {
    return (
      <div className="space-y-6" data-testid="forgot-password-sent">
        <span className="w-11 h-11 rounded-xl bg-primary/10 flex items-center justify-center">
          <MailCheck className="w-6 h-6 text-primary" />
        </span>
        <div className="space-y-2">
          <h2 className="text-2xl md:text-3xl font-bold font-outfit">Guarda la posta</h2>
          <p className="text-muted-foreground">
            Se <span className="font-medium text-foreground">{email}</span> è registrato, trovi il link per
            rifare la password. Vale un'ora e una volta sola.
          </p>
        </div>
        <Button variant="outline" className="w-full h-11" onClick={onBack} data-testid="back-to-login-btn">
          Torna all'accesso
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="forgot-password-step">
      <span className="w-11 h-11 rounded-xl bg-primary/10 flex items-center justify-center">
        <KeyRound className="w-6 h-6 text-primary" />
      </span>
      <div className="space-y-2">
        <h2 className="text-2xl md:text-3xl font-bold font-outfit">Password dimenticata</h2>
        <p className="text-muted-foreground">
          Scrivi l'email dell'account: ti mandiamo un link per sceglierne una nuova.
        </p>
      </div>

      <form onSubmit={submit} className="space-y-5">
        <div className="space-y-2">
          <Label htmlFor="forgot-email">Email</Label>
          <Input id="forgot-email" type="email" required value={email} className="h-11"
            placeholder="tu@esempio.com" onChange={(e) => setEmail(e.target.value)}
            data-testid="forgot-email-input" />
        </div>

        {error && (
          <p className="text-sm text-destructive bg-destructive/10 p-3 rounded-md" data-testid="forgot-error">
            {error}
          </p>
        )}

        <Button type="submit" className="w-full h-11" disabled={busy || !email} data-testid="send-reset-link-btn">
          {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
          Mandami il link
          {!busy && <ArrowRight className="w-4 h-4 ml-2" />}
        </Button>
      </form>

      <button type="button" onClick={onBack} data-testid="cancel-forgot-btn"
        className="text-sm text-muted-foreground hover:text-primary transition-colors">
        Me la ricordo, torna all'accesso
      </button>
    </div>
  );
};

export default ForgotPasswordStep;
